<template>
  <Breadcrumb />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body" v-if="notificationSettingData">
          <SetLoader v-if="notificationSettingIsLoading" />
          <form
            class="row g-3 form-notification-setting-edit"
            novalidate
            v-else
          >
            <div v-if="errors.length > 0" class="alert alert-warning">
              <ul class="mb-0">
                <li v-for="error in errors" v-bind:key="error">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <label for="NotificationType" class="form-label required">{{
                $t(
                  "NotificationSettings.NotifierType",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}</label>
              <FormSelect
                type="SelectWithLocalData"
                :selectedData="selectedNotifierType"
                :allowEmpty="false"
                :data="notifierTypeData"
                @onChange="onChangeForNotifierType"
              />
            </div>
            <div class="col-md-6">
              <label for="displayName" class="form-label required"
                >{{
                  $t(
                    "NotificationSettings.DisplayName",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="displayName"
                v-model="notificationSettingData.displayName"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
                required
              />
            </div>
            <div class="col-md-6" v-if="!notifierTypeEmail">
              <label for="userName" class="form-label">{{
                $t(
                  "NotificationSettings.UserName",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}</label>
              <input
                name="userName"
                class="form-control"
                id="userName"
                v-model="notificationSettingData.userName"
                :spellcheck="this.$isTextSpellCheck"
                type="text"
              />
            </div>
            <div class="col-md-6" v-if="!notifierTypeEmail">
              <label for="passwordSms" class="form-label"
                >{{
                  $t(
                    "NotificationSettings.Password",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                name="passwordSms"
                class="form-control"
                id="passwordSms"
                v-model="notificationSettingData.password"
                :spellcheck="this.$isTextSpellCheck"
                type="password"
              />
            </div>
            <div class="col-md-6" v-if="notifierTypeEmail">
              <label for="passwordEmail" class="form-label"
                >{{
                  $t(
                    "NotificationSettings.Password",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="password"
                class="form-control"
                id="passwordEmail"
                :spellcheck="this.$isTextSpellCheck"
                v-model="notificationSettingData.password"
              />
            </div>
            <div class="col-md-6" v-if="notifierTypeEmail">
              <label for="senderEmail" class="form-label required">{{
                $t(
                  "NotificationSettings.SenderEmail",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}</label>
              <input
                name="senderEmail"
                class="form-control"
                id="senderEmail"
                v-model="notificationSettingData.senderEmail"
                :spellcheck="this.$isTextSpellCheck"
                type="text"
                required
              />
            </div>
            <div class="col-md-6" v-if="notifierTypeEmail">
              <label for="port" class="form-label required"
                >{{
                  $t(
                    "NotificationSettings.Port",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                name="port"
                class="form-control"
                id="port"
                v-model="notificationSettingData.port"
                :spellcheck="this.$isTextSpellCheck"
                type="number"
                required
              />
            </div>
            <div class="col-md-6" v-if="notifierTypeEmail">
              <label for="host" class="form-label required">{{
                $t(
                  "NotificationSettings.Host",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}</label>
              <input
                name="host"
                class="form-control"
                id="host"
                v-model="notificationSettingData.host"
                :spellcheck="this.$isTextSpellCheck"
                type="text"
                required
              />
            </div>
            <div class="col-md-6">
              <div class="form-check" v-if="notifierTypeEmail">
                <label for="IsExchangeServer" class="form-label">{{
                  $t(
                    "NotificationSettings.IsExchangeServer",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsExchangeServer"
                  v-model="notificationSettingData.isExchangeServer"
                />
              </div>
              <div class="form-check" v-if="notifierTypeEmail">
                <label for="SSL" class="form-label">{{
                  $t(
                    "NotificationSettings.SSL",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SSL"
                  v-model="notificationSettingData.isSsl"
                />
              </div>
              <div class="form-check">
                <label for="IsActive" class="form-label">{{
                  $t(
                    "BaseModelFields.IsActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsActive"
                  v-model="notificationSettingData.isActive"
                />
              </div>
              <div class="form-check">
                <label for="IsBeingUsedForSystemEmail" class="form-label">{{
                  $t(
                    "NotificationSettings.IsBeingUsedForSystemEmail",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsBeingUsedForSystemEmail"
                  v-model="notificationSettingData.isBeingUsedForSystemEmail"
                />
              </div>
            </div>
            <div class="col-md-6" v-if="notificationSettingData.notifierTypeId">
              <template v-if="notifierTypeEmail">
                <button
                  type="button"
                  class="btn btn-warning me-2"
                  data-bs-target="#modalNotificationSettingTest"
                  data-bs-toggle="modal"
                >
                  <i class="bi bi-envelope"></i>
                  {{
                    $t(
                      "Components.NotificationSettingTestModal.EmailTest",
                      {},
                      { locale: this.$store.state.activeLang }
                    )
                  }}
                </button>
              </template>
              <template v-else>
                <button
                  type="button"
                  class="btn btn-success me-2"
                  @click="smsBalanceButtonClicked"
                  data-bs-target="#modalNotificationSMSBalance"
                  data-bs-toggle="modal"
                >
                  {{
                    $t(
                      "Components.NotificationSMSBalanceModal.Title",
                      {},
                      { locale: this.$store.state.activeLang }
                    )
                  }}
                </button>
                <button
                  type="button"
                  class="btn btn-warning"
                  data-bs-target="#modalNotificationSettingTest"
                  data-bs-toggle="modal"
                >
                  <i class="bi bi-phone"></i>
                  {{
                    $t(
                      "Components.NotificationSettingTestModal.SMSTest",
                      {},
                      { locale: this.$store.state.activeLang }
                    )
                  }}
                </button>
              </template>
            </div>
            <ActionButtons
              @methodSave="onSubmit('btn-save')"
              :isNewRecord="false"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
  <NotificationSettingTestModal
    :isEmailTest="notifierTypeEmail"
    :userName="notificationSettingData.userName"
    :password="notificationSettingData.password"
    :displayName="notificationSettingData.displayName"
    :isExchangeServer="notificationSettingData.isExchangeServer"
    :domain="notificationSettingData.domain"
    :senderEmail="notificationSettingData.senderEmail"
    :host="notificationSettingData.host"
    :port="notificationSettingData.port"
    :isSsl="notificationSettingData.isSsl"
  />
  <NotificationSMSBalanceModal
    :userName="notificationSettingData.userName"
    :password="notificationSettingData.password"
    :modalOpenButtonClick="smsBalanceButtonClick"
  />
</template>
<script>
import NotificationSettingTestModal from "@/components/page-partials/notification-settings/SettingTestModal.vue";
import NotificationSMSBalanceModal from "@/components/page-partials/notification-settings/SMSBalanceModal.vue";
import $ from "jquery";
export default {
  name: "NotificationSettingEdit",
  components: { NotificationSettingTestModal, NotificationSMSBalanceModal },
  data() {
    return {
      notificationSettingIsLoading: true,
      smsBalanceButtonClick: false,
      submitButtonHtml: String.format(
        '<span class="loading-block"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span> {0}</span></span>',
        this.$t(
          "Buttons.PleaseWait",
          {},
          { locale: this.$store.state.activeLang }
        )
      ),
      disabledButtonClasses: ".btn-save",
      errors: [],
      notificationSettingData: {},
      notifierTypeData: [
        {
          key: 1,
          value: this.$t(
            "NotificationSettings.Email",
            {},
            { locale: this.$store.state.activeLang }
          ),
        },
        {
          key: 2,
          value: this.$t(
            "NotificationSettings.SMS",
            {},
            { locale: this.$store.state.activeLang }
          ),
        },
      ],
      selectedNotifierType: [],
      notifierTypeEmail: false,
    };
  },
  methods: {
    onChangeForNotifierType: function (selected) {
      this.notifierTypeEmail = selected.key == 1 ? true : false;
      this.notificationSettingData.notifierTypeId = selected.key;
      this.setDefaultValuesForNotifierType();
    },
    setDefaultValuesForNotifierType() {
      this.notificationSettingData.host = null;
      this.notificationSettingData.userName = null;
      this.notificationSettingData.password = null;
      this.notificationSettingData.senderEmail = null;
      this.notificationSettingData.port = 0;
      this.notificationSettingData.isSsl = false;
      this.notificationSettingData.isExchangeServer = false;
    },
    smsBalanceButtonClicked() {
      this.smsBalanceButtonClick = !this.smsBalanceButtonClick;
    },
    getNotifierTypeName(valueTypeId) {
      var text = this.$t(
        "NotificationSettings.Email",
        {},
        { locale: this.$store.state.activeLang }
      );
      if (valueTypeId == 2) {
        text = this.$t(
          "NotificationSettings.SMS",
          {},
          { locale: this.$store.state.activeLang }
        );
      }
      return text;
    },
    getNotifierType() {
      this.notificationSettingIsLoading = true;
      this.$prodGatewayAxios
        .get(
          String.format(
            "/Lcdp-NotifierSettingGet?id={0}",
            this.$route.params.notifierSettingId
          )
        )
        .then((response) => {
          this.notificationSettingIsLoading = false;
          this.notificationSettingData = response.data;
          this.notifierTypeEmail = response.data.notifierTypeId == 1;
          if (!String.isNullOrWhiteSpace(response.data.notifierTypeId)) {
            this.selectedNotifierType.push({
              key: response.data.notifierTypeId,
              value: this.getNotifierTypeName(response.data.notifierTypeId),
            });
          }

          //decrypt values
          this.notificationSettingData.host = this.$root.decrypt(
            this.notificationSettingData.host
          );
          this.notificationSettingData.senderEmail = this.$root.decrypt(
            this.notificationSettingData.senderEmail
          );
          this.notificationSettingData.password = this.$root.decrypt(
            this.notificationSettingData.password
          );
          this.notificationSettingData.userName = this.$root.decrypt(
            this.notificationSettingData.userName
          );
          this.notificationSettingData.domain = this.$root.decrypt(
            this.notificationSettingData.domain
          );
        })
        .catch(function (error) {
          //alert(error);
        });
    },
    onSubmit(buttonName) {
      var form = $(".form-notification-setting-edit");
      form.addClass("was-validated");
      if (
        !form[0].checkValidity() ||
        form.find(".ms-invalid:visible").length > 0
      ) {
        return;
      }

      var button = $(String.format(".{0}", buttonName)),
        firstSpan = button.find("span:first"),
        loadingBlock = button.find(".loading-block"),
        disabledButtons = $(this.disabledButtonClasses);

      disabledButtons.prop("disabled", true);
      firstSpan.hide();
      if (loadingBlock.length === 0) {
        firstSpan.after(this.submitButtonHtml);
        loadingBlock = button.find(".loading-block");
      } else {
        loadingBlock.show();
      }

      var model = { ...this.notificationSettingData };
      model.userName = this.$root.encrypt(model.userName);
      model.password = this.$root.encrypt(model.password);

      if (this.notifierTypeEmail) {
        model.senderEmail = this.$root.encrypt(model.senderEmail);
        model.host = this.$root.encrypt(model.host);
        model.domain = this.$root.encrypt(model.domain);
      }

      this.errors = [];
      this.$prodGatewayAxios
        .post("/Lcdp-NotifierSettingEdit", model)
        .then((r) => {
          var response = r.data;
          if (response.isOk) {
            this.$router.push("/NotificationSetting/List");
          } else {
            firstSpan.show();
            loadingBlock.hide();
            disabledButtons.prop("disabled", false);
            this.errors.push(response.msg);
          }
        })
        .catch((r) => {
          firstSpan.show();
          loadingBlock.hide();
          disabledButtons.prop("disabled", false);
          this.errors.push(r);
        });
    },
  },
  mounted() {
    this.getNotifierType();
  },
};
</script>
